/* URL du service */
export const REST_URL = import.meta.env.VITE_REST_URL as string;
export const REST_UTILS_URL = import.meta.env.VITE_REST_UTILS_URL as string;
export const TEMPLATE_SERVER_URL = import.meta.env.VITE_URL_TEMPLATE_SERVER as string;

export const URL_DOWNLOAD_VIA_GED = import.meta.env.VITE_DOWNLOAD_VIA_GED;

export const OAUTH_URL = import.meta.env.VITE_OAUTH_URL;
export const CLIENT_ID = "app:barcode";
export const REALM = import.meta.env.VITE_OAUTH_REALM || "octal";

export const CARD_SIZE = import.meta.env.VITE_CARD_SIZE || undefined;

/** interval de mise à jour du panel information */
export const INTERVAL_DATA_HOME = parseInt(import.meta.env.VITE_INTERVAL_DATA_HOME || "60000", 10);

/**
 * URL de l'application déployé
 * ATTENTION, CETTE VARIABLE N'EST PRIS EN CHARGE QUE POUR LE DEPLOIEMENT
 */
export const PUBLIC_URL = (import.meta.env.PROD ? import.meta.env.BASE_URL || "/" : "/") as string;

export const COOKIE_TOKEN = "octal-scenario-token";
export const COOKIE_PATH = "octal-scenario-path";
export const COOKIE_LANG = "octal-user-lang";
